import {
    LitElement,
    html,
    css,
    nothing
} from "./lit-core.min.js";
import { fetchFromShopify, rateLimitedLoop, fetchData } from './util.js';

/*
Trying to make a reuse able dropdown component
you cant do much filtering with the api with metaobjects so hacks all around
*/

class NestedDropdown extends LitElement {
    static styles = css`
        a {
            margin: 10px;
        }
        select {
            padding: 5px;
            font-size: 16px;
            color: #1e2d7d;
            background: #fff;
            resize: none;
            box-shadow: 0 1px #d4d6d8, .25) inset;
            border-radius: 2px;
            border-color: #d4d6d8;
            height: 48px;
            font-size: max(1rem, 16px);
            line-height: normal;
            transition: border-color .2s ease-in-out, box-shadow .2s ease-in-out, color .2s ease-in-out;
            display: block;
            margin: 10px 0;
        }
        .content {
            display: flex;
            justify-content: center;
            gap: 1rem;
            max-width: 100%;
        }
        .model {
            grid-column: 5;
            grid-row: 1;
            place-content: center;
        }
        @media only screen and (max-width: 768px) {
             .content {
                display: grid;
                grid-template-columns: 1fr 1fr;
            }
            .model {
                grid-column: unset;
                grid-row: unset;
                place-content: center;
                grid-column: 1;
            }
        }
    `;

    static properties = {
        selectedValues: { type: Array },
        dropdownOptions: { type: Array },
        namespaces: {
            type: Array, attribute: 'namespaces', converter: {
                fromAttribute: (value) => JSON.parse(value),
                toAttribute: (value) => JSON.stringify(value),
            }
        }
    };

    constructor() {
        super();
        this.selectedValues = [];
        this.dropdownOptions = [];
        this.dropdownLabels = ['Select Brand', 'Select Entry Type', 'Select Motor Type']; // Customize as needed
        this.namespaces = [];
        this.model = {}
        this.showInfo = false;
    }

    connectedCallback() {
        super.connectedCallback();
        if (!this.namespaces.length) {
            console.error('Namespaces not provided!');
            return;
        }
        this.maxLevels = this.namespaces.length > 1 ? this.namespaces.length : this.namespaces.length + 1;
        this.selectedValues = Array(this.maxLevels).fill('');
        this.dropdownOptions = Array(this.maxLevels).fill([]);
        this.fetchInitialOptions();
    }

    render() {
        return html`
        <div class="content">
            ${this.getActiveLevels().map(level => this.renderDropdown(level))}
            <br>
            ${this.showInfo ? this.renderInfoMessage() : ''}
        </div>
    `;
    }

    renderDropdown(level) {
        const options = this.dropdownOptions[level] || [];
        const isDisabled = level > 0 && !this.selectedValues[level - 1];
        const label = this.dropdownLabels[level] || `Select Level Modal`; // Default if no label is provided
    
        return html`
            <div class="dropdown-container">
                <label for="dropdown-${level}">${label}</label>
                <select 
                    id="dropdown-${level}" 
                    @change="${e => this.onSelectionChange(e, level)}" 
                    ?disabled="${isDisabled}" 
                    value="${options.length > 0 ? options[0].value : ''}">
                    <option value="">Select an option</option>
                    ${options.map(item => html`<option data-url="${item.text}" data-pdf="${item.pdf}" value="${item.value}">${item.display_text}</option>`)}
                </select>
            </div>
        `;
    }

    async onSelectionChange(e, level) {
        this.model = null;
        this.showInfo = false;
        const newValue = e.target.value;
        const newSelectedValues = [...this.selectedValues];
        const selectedText = e.target.options[e.target.selectedIndex].text;
        const selectedValue = e.target.options[e.target.selectedIndex].getAttribute("data-url")
        const type = this.namespaces[level];
        newSelectedValues[level] = newValue;
        newSelectedValues.fill('', level + 1);

        this.selectedValues = newSelectedValues

        if (newValue) {
            await this.fetchOptions(level + 1, newValue, type, selectedText, e);
        } else {
            this.dropdownOptions.fill([], level + 1);
            this.requestUpdate();
        }
    }

    renderInfoMessage() {
        return html`<a class="model" target="_blank" href="${this.model.link}">${this.model.text}</a>`;
    }

    async fetchOptions(level, id, type, text, e) {
        if (this.namespaces.length === level && this.namespaces.length !== 1) {
            const pdf = e.target.options[e.target.selectedIndex].getAttribute("data-pdf")
            this.model = {text: text, link: pdf}
            this.showInfo = true; // Set flag to show info
            this.requestUpdate(); // Update the component to re-render with info
            return;
        }

        if ((this.namespaces.length - 1) === level || this.namespaces.length === 1) {
            await this.handleShopifyFetch(level, type, text, e);
        } else {
            await this.handleOtherFetch(level, id, type);
        }
    }

    async handleShopifyFetch(level, type, text, e) {
        if (level > this.namespaces.length) {
            const pdf = e.target.options[e.target.selectedIndex].getAttribute("data-pdf")
            this.model = {text: text, link: pdf}
            this.showInfo = true; // Set flag to show info
            this.requestUpdate(); // Update the component to re-render with info
            return;
        }

        const value = e.target.options[e.target.selectedIndex].getAttribute("data-url");
        const typePath = this.namespaces.length === 1 ? this.namespaces[0] : this.namespaces[level].replace(/_/g, '-');
        const url = `${window.Shopify.routes.root}pages/${typePath}/${value.toLowerCase()}`;
        const results = await fetchFromShopify(url);
        const [modalArray] = Object.values(results);
        this.dropdownOptions[level] = modalArray.map(item => ({ value: item.name, text: item.name, pdf: item.pdf, display_text: item.name }));
        this.requestUpdate();
        this.selectedValues.fill('', level + 1);
    }

    async handleOtherFetch(level, id, type) {
        try {
            const ids = await this.fetchTheThings(id, type);
            const data = (await rateLimitedLoop(ids, id => this.fetchOtherThings(id, level))).flat();

            this.dropdownOptions[level] = data.map(item => ({ value: item.value, text: item.text, display_text: item.text.split("-")[0] }));
            this.requestUpdate();
            this.selectedValues.fill('', level + 1);
        } catch (error) {
            console.error('Error fetching options:', error);
        }
    }

    async fetchTheThings(id, type) {

        const query = `
            {
                metaobject(id: "gid://shopify/Metaobject/${id}") {
                    field(key: "${type}") {
                        value
                    }
                }
            }
        `;
        try {
            const data = await fetchData(query);
            return JSON.parse(data.data.metaobject.field.value);
        } catch (error) {
            throw new Error('Error fetching data:', error);
        }
    }

    async fetchOtherThings(id, level) {
        // unsure how to fix
        const fieldKey = level === this.namespaces.length - 1 ? 'name' : 'type';

        const query = `
            {
                metaobject(id: "${id}") {
                    name: field(key: "${fieldKey}") {
                        value
                    }
                }
            }
        `;
        try {
            const data = await fetchData(query);
            // const children = JSON.parse(data.data.metaobject.children.value);
            // const ids = children.map(item => item.split('/').pop());
            return [{ text: data.data.metaobject.name.value, value: id.split('/').pop() }];
        } catch (error) {
            throw new Error('Error fetching data:', error);
        }
    }

    getActiveLevels() {
        return Array.from({ length: this.maxLevels }, (_, i) => i);
    }

    async fetchInitialOptions() {
        const template = document.getElementById('options-template');
        if (template) {
            const optionsHtml = template.innerHTML;
            this.dropdownOptions[0] = this.parseOptionsHtml(optionsHtml);
            this.requestUpdate();
        }
    }

    parseOptionsHtml(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        return Array.from(doc.querySelectorAll('option')).map(option => ({
            value: option.value,
            text: option.textContent,
            display_text: option.textContent
        }));
    }
}
customElements.define('nested-dropdown', NestedDropdown);